import { useEffect, useState } from "react";
import { currentSession, onSessionChange } from "./auth";
import type { Operator } from "../types";

// The backend grants a small set of coarse roles; the console has a richer vocabulary for
// what each screen needs. This is the one place the two meet, and the most privileged role
// an operator holds is the one that decides what they see.
const ROLE_BY_GRANT: Array<[string, Operator["role"]]> = [
  ["admin", "SUPER_ADMIN"],
  ["ops", "OPS_MANAGER"],
  ["finance", "FINANCE"],
  ["moderator", "MODERATOR"],
  ["support", "SUPPORT"],
];

export function operatorFromSession(): Operator | null {
  const session = currentSession();
  if (!session) return null;

  const granted = new Set(session.roles);
  const match = ROLE_BY_GRANT.find(([grant]) => granted.has(grant));
  return {
    id: session.id,
    name: session.displayName || "Operator",
    // An operator with no roles yet can sign in and see nothing, which is the right
    // default: authority is granted deliberately rather than assumed.
    role: match ? match[1] : "SUPPORT",
    zones: [],
  };
}

/** Re-reads the stored session whenever it changes, so signing out updates the whole app. */
export function useSession() {
  const [operator, setOperator] = useState<Operator | null>(operatorFromSession);
  useEffect(() => onSessionChange(() => setOperator(operatorFromSession())), []);
  return operator;
}
